import { render, staticRenderFns } from "./comp-tagihan-table.vue?vue&type=template&id=00d0fd1c&scoped=true&"
import script from "./comp-tagihan-table.vue?vue&type=script&lang=js&"
export * from "./comp-tagihan-table.vue?vue&type=script&lang=js&"
import style0 from "./comp-tagihan-table.vue?vue&type=style&index=0&id=00d0fd1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d0fd1c",
  null
  
)

export default component.exports